import Axios from 'axios';

class LevelsService {
  getGroups() {
    return Axios.get('/admin/levels', {
      params: {
        only_groups: true,
        only_members: false,
      },
    })
      .then(({ data }) => data);
  }

  getMembers() {
    return Axios.get('/admin/levels', {
      params: {
        only_groups: false,
        only_members: true,
      },
    })
      .then(({ data }) => data);
  }

  getAll() {
    return Axios.get('/admin/levels')
      .then(({ data }) => data);
  }
}

export default new LevelsService();
